import { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl } from '../config/api';

const useJobsByCompany = (companyId) => {
  const [jobs, setjobs] = useState([]);

  useEffect(() => {
    const fetchCompanyJobs = async () => {
      try {
        const response = await axios.get(getApiUrl(`/job/${companyId}`));
        setjobs(response.data)
      } catch (error) {
        console.error('Failed to fetch job postings:', error);
      }
    };

    fetchCompanyJobs();
  }, [companyId]);

  return jobs;
};

export default useJobsByCompany;
